const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      return {
        token: action.payload.token,
        userID: action.payload.userID,
        isAdmin: action.payload.isAdmin,
        phoneNumber: action.payload.phoneNumber,
      };
    }

    case "LOGOUT": {
      return {
        token: null,
        userID: null,
        isAdmin: null,
        phoneNumber: null,
      };
    }

    default:
      return state;
  }
};

export default AuthReducer;
